export const ENABLE_LEGACY_TRADE_INTERFACE = false;
